import { css } from 'styled-components'

const fonts = css`
    @font-face {
        font-family: 'interface';
        src: url('/static/webfonts/InterFace_W_Rg.eot?giphy');
        src: url('/static/webfonts/InterFace_W_Rg.eot?giphy#iefix') format('embedded-opentype'),
            url('/static/webfonts/InterFace_W_Rg.woff2?giphy') format('woff2'),
            url('/static/webfonts/InterFace_W_Rg.woff?giphy') format('woff');
        font-weight: normal;
        font-style: normal;
    }
    @font-face {
        font-family: 'interface';
        src: url('/static/webfonts/InterFace_W_Bd.eot?giphy');
        src: url('/static/webfonts/InterFace_W_Bd.eot?giphy#iefix') format('embedded-opentype'),
            url('/static/webfonts/InterFace_W_Bd.woff2?giphy') format('woff2'),
            url('/static/webfonts/InterFace_W_Bd.woff?giphy') format('woff');
        font-weight: bold;
        font-style: normal;
    }
    @font-face {
        font-family: 'interface';
        src: url('/static/webfonts/InterFace_W_It.eot?giphy');
        src: url('/static/webfonts/InterFace_W_It.eot?giphy#iefix') format('embedded-opentype'),
            url('/static/webfonts/InterFace_W_It.woff2?giphy') format('woff2'),
            url('/static/webfonts/InterFace_W_It.woff?giphy') format('woff');
        font-weight: normal;
        font-style: italic;
    }
    @font-face {
        font-family: 'interface';
        src: url('/static/webfonts/InterFace_W_XBd.eot?giphy');
        src: url('/static/webfonts/InterFace_W_XBd.eot?giphy#iefix') format('embedded-opentype'),
            url('/static/webfonts/InterFace_W_XBd.woff?giphy') format('woff');
        font-weight: 900;
        font-style: normal;
    }
    @font-face {
        font-family: 'nexablack';
        src: url('/static/webfonts/nexa_black-webfont.eot?giphy');
        src: url('/static/webfonts/nexa_black-webfont.eot?giphy#iefix') format('embedded-opentype'),
            url('/static/webfonts/nexa_black-webfont.woff2?giphy') format('woff2'),
            url('/static/webfonts/nexa_black-webfont.woff?giphy') format('woff'),
            url('/static/webfonts/nexa_black-webfont.ttf?giphy') format('truetype'),
            url('/static/webfonts/nexa_black-webfont.svg?giphy#nexablack') format('svg');
        font-weight: normal;
        font-style: normal;
    }
    @font-face {
        font-family: 'nexabook';
        src: url('/static/webfonts/nexa_book-webfont.woff2') format('woff2'),
            url('/static/webfonts/nexa_book-webfont.woff') format('woff');
        font-weight: normal;
        font-style: normal;
    }
    @font-face {
        font-family: 'emulogic';
        src: url('/static/webfonts/emulogic.eot');
        src: url('/static/webfonts/emulogic?#iefix') format('embedded-opentype'),
            url('/static/webfonts/emulogic.woff2') format('woff2'), url('/static/webfonts/emulogic.woff') format('woff'),
            url('/static/webfonts/emulogic.ttf') format('truetype'),
            url('/static/webfonts/emulogic.svg#emulogic') format('svg');
        font-weight: normal;
        font-style: normal;
    }
    @font-face {
        font-family: 'meme';
        src: url('/static/webfonts/meme.woff2') format('woff2'), url('/static/webfonts/meme.woff') format('woff');
        font-weight: normal;
        font-style: normal;
    }
    @font-face {
        font-family: 'SSSocial';
        src: url('/static/webfonts/ss-social-regular.eot');
        src: url('/static/webfonts/ss-social-regular.eot?#iefix') format('embedded-opentype'),
            url('/static/webfonts/ss-social-regular.woff') format('woff'),
            url('/static/webfonts/ss-social-regular.ttf') format('truetype'),
            url('/static/webfonts/ss-social-regular.svg#SSSocialRegular') format('svg');
        font-weight: bold;
        font-style: normal;
    }
    @font-face {
        font-family: 'SSStandard';
        src: url('/static/webfonts/ss-standard.eot');
        src: url('/static/webfonts/ss-standard.eot?#iefix') format('embedded-opentype'),
            url('/static/webfonts/ss-standard.woff') format('woff'),
            url('/static/webfonts/ss-standard.ttf') format('truetype'),
            url('/static/webfonts/ss-standard.svg#SSStandard') format('svg');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'giphy';
        src: url('/static/webfonts/giphy.ttf?-8lsmq3666') format('truetype'),
            url('/static/webfonts/giphy.woff?-8lsmq3666') format('woff'),
            url('/static/webfonts/giphy.svg?-8lsmq3666#giphy') format('svg');
        font-weight: normal;
        font-style: normal;
    }
`

export default fonts
